module.exports = __webpack_public_path__ + "img/20d.306fcd52.jpg";